import { render, staticRenderFns } from "./tan_carbase_bieming.vue?vue&type=template&id=178faa48&scoped=true"
import script from "./tan_carbase_bieming.vue?vue&type=script&lang=js"
export * from "./tan_carbase_bieming.vue?vue&type=script&lang=js"
import style0 from "./tan_carbase_bieming.vue?vue&type=style&index=0&id=178faa48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178faa48",
  null
  
)

export default component.exports